import { TwMerge } from '@firmable/utilities';

type GlassProps = {
  children: React.ReactNode;
  className?: string;
};

export const Glass = ({ children, className }: GlassProps) => {
  return (
    <div
      className={TwMerge(
        'rounded-xl border border-white/30 backdrop-blur-[12px]',
        className
      )}
      style={{
        backgroundImage:
          'linear-gradient(158deg, rgba(0, 0, 0, 0.2) 50%, rgba(102, 102, 102, 0) 100%)',
      }}
    >
      {children}
    </div>
  );
};
